import React from 'react';
import { Card, Typography } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import XlsxSectionMapper from '../../../components/common/XlsxSectionMapper';
import Button from '../../../components/common/Button';

const { Title } = Typography;

const CorXlsxSectionMapper: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Card
      title={(
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
          <Button icon={<LeftOutlined />} type="text" aria-label="Back" onClick={() => navigate(-1)} />
          <Title level={3} style={{ margin: 0 }}>XLSX Section Mapper</Title>
        </span>
      )}
      style={{ margin: 24 }}
    >
      <XlsxSectionMapper />
    </Card>
  );
};

export default CorXlsxSectionMapper;
